// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Tlfn5","noInteraction":"EventWrapper_noInteraction__2GKGv"};